var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "md-table",
        { staticClass: "skeleton-table" },
        _vm._l(5, function (n) {
          return _c(
            "md-table-row",
            { key: n, staticClass: "skeleton-table--row" },
            [_c("skeleton")],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }